import { useState, useEffect, useCallback } from "react";
import { rqx } from "../request/API";
import { env } from "../Env";

const tool_id = process.env.REACT_APP_TID_BIZ;

export const useCompanyUsers = ({ companyId }) => {
  const [toolUsers, setToolUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    setLoadingUsers(true);
    rqx
      .get(`<<global>>/${env() === 'local' ? 'dev' : env()}/tooluser/gettooluser`, {
        company_id: companyId,
        tool_id,
        ref: "active",
      })
      .then((result) => {
        setToolUsers(result?.users || []);
      })
      .catch(() => setToolUsers([]))
      .finally(() => setLoadingUsers(false));
  }, [companyId]);

  const getUserById = useCallback(
    (id) => toolUsers.find((u) => u.id === id) || null,
    [toolUsers]
  );

  return { toolUsers, loadingUsers, getUserById };
};
